import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AddNoteModal = ({ isOpen, onClose, unit, onAdd }) => {
  const [noteType, setNoteType] = useState('general');
  const [noteText, setNoteText] = useState('');
  const [error, setError] = useState('');

  if (!isOpen || !unit) return null;

  const noteTypeOptions = [
    { value: 'general', label: 'General Note' },
    { value: 'maintenance', label: 'Maintenance Issue' },
    { value: 'tenant_request', label: 'Tenant Request' },
    { value: 'inspection', label: 'Inspection Report' },
    { value: 'pricing', label: 'Pricing Discussion' }
  ];

  const handleSubmit = () => {
    if (!noteText?.trim()) {
      setError('Please enter a note');
      return;
    }

    onAdd({
      unitId: unit?.id,
      type: noteType,
      text: noteText,
      timestamp: new Date()?.toISOString()
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background bg-opacity-80">
      <div className="bg-card rounded-lg shadow-brand-2xl w-full max-w-lg">
        <div className="border-b border-border p-4 md:p-6 flex items-center justify-between">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
              Add Note
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              Unit {unit?.unitNumber} • Floor {unit?.floor}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-smooth"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-4 md:p-6 space-y-4">
          <Select
            label="Note Type"
            options={noteTypeOptions}
            value={noteType}
            onChange={setNoteType}
            description="Categorize this note for better organization"
          />

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Note Content <span className="text-error">*</span>
            </label>
            <textarea
              value={noteText}
              onChange={(e) => {
                setNoteText(e?.target?.value);
                setError('');
              }}
              placeholder="Enter your note here..."
              rows={6}
              className={`w-full px-3 py-2 border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none ${
                error ? 'border-error' : 'border-border'
              }`}
            />
            {error && (
              <p className="mt-1 text-sm text-error">{error}</p>
            )}
          </div>

          <div className="bg-muted bg-opacity-30 rounded-lg p-3 flex items-start gap-2">
            <Icon name="Info" size={16} className="text-primary mt-0.5" />
            <p className="text-xs text-muted-foreground">
              Notes are timestamped and associated with your user account. They will be visible to all team members with access to this unit.
            </p>
          </div>
        </div>

        <div className="border-t border-border p-4 md:p-6 flex gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleSubmit}
            iconName="Check"
            fullWidth
          >
            Add Note
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNoteModal;